import businessClient from 'src/services/clients/business'
import { IMeta, ISalesItem, ISalesItemView } from 'src/common/interfaces/index.js'

const ISalesListResponse = { meta: IMeta, data: { list: [ISalesItem], count: 0 } }
const ISalesViewResponse = { meta: IMeta, data: ISalesItemView }

export const sales = {
  /**
   * @param {store_id: number} filter
   * @return {ISalesListResponse}
   */
  list(filter, signal) {
    return businessClient().post('sale/portal/list', { filter }, { signal })
  },

  /**
   * @param {id: number} filter
   * @return {ISalesViewResponse}
   */
  view(filter, signal) {
    return businessClient().post('sale/portal/view', { filter }, { signal })
  },

  /**
   * @param {id: number, status: string, prep_minutes: number} data
   */
  updateStatus(data, signal) {
    return businessClient().post('sale/update-status', { data }, { signal })
  },
}
